module.exports = __webpack_public_path__ + "static/img/step-1033.2986ac5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-1033.png
// module id = 72Qt
// module chunks = 1